import SymptomsBlock from './symptoms-block'

export default SymptomsBlock
